interface PostContentProps {
  content: string;
}

export function PostContent({ content }: PostContentProps) {
  return <div className="line-clamp-3 min-h-[62px] text-sm leading-5 text-zinc-900">{content}</div>;
}
